const registrations = {
	status: {
		open: "Open",
		pending: "In afwachting",
		completed: "Afgerond",
		deleted: "Verwijdert",
		expired: "Verlopen",
		matched: "Gematcht",
		denied: "Niet geselecteerd",
		canceled: "Geannuleerd",
	},
	"recent-list": {
		title: "Nieuwe aanmeldingen",
		empty: "Je hebt nog geen aanmeldingen op jouw opdrachten",
	},
	card: {
		cta: "Aanmelding bekijken",
	},
	buttons: {
		review: "Review plaatsen",
		denie: "Afwijzen",
		accept: "Accepteren",
		"cancel-task": "Opdracht annuleren",
		payout: "Uitbetalen",
	},
	"registration-head": {
		"full-cv": "Volledige cv",
	},
	"registration-match-details": {
		envelope: "Overeenkomst",
		payment: "Betaling",
		"no-payment":
			"Er is nog geen betaling voor deze match. Maak een betaling aan zodat de opdracht afgerond kan worden.",
		"create-payment": "Betaling aanmaken",
	},
	"registration-reviews": {
		client: "Opdrachtgever",
		contractor: "Opdrachtnemer",
		review: {
			title: "Review",
			"not-created": "Nog geen review ontvangen",
			"created-by": "Aangemaakt door",
		},
	},
	"select-registration-pane": {
		back: "Terug naar aanmeldingen",
		empty: {
			title: "Selecteer eerst een aanmelding",
		},
	},
	"registrations-sidebar": {
		tabs: {
			all: "Alles",
			accepted: "Gematcht",
			open: "Open",
			denied: "Afgewezen",
			favorites: "Favorieten",
		},
	},
	"registration-contact-details": {
		title: "Contactgegevens",
		telephone: "Telefoonnummer",
		email: "Email",
		website: "Website",
	},
};

export default registrations;
